import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SystemService } from './service/system-service.service';

@Component({
  selector: 'sibat-maintenance',
  templateUrl: './maintenance.component.html',
  styles: [],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  private checkSubscription!: Subscription;
  private readonly checkInterval = 60000;

  constructor(private systemService: SystemService, private router: Router) {}

  ngOnInit(): void {
    this.startPeriodicCheck();
  }

  ngOnDestroy(): void {
    if (this.checkSubscription) {
      this.checkSubscription.unsubscribe();
    }
  }

  private startPeriodicCheck(): void {
    this.checkSubscription = interval(this.checkInterval)
      .pipe(switchMap(() => this.systemService.getMaintenanceStatus()))
      .subscribe(
        isMaintenance => {
          if (!isMaintenance) {
            this.router.navigate(['/signin']);
          }
        },
        error => {
          console.error(error);
        }
      );
  }
}
